import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { BliksyMessageRole } from '../chat-with-bliksy/chat-with-bliksy.schema';
import { ChatMessageEnvelopeSchema } from '../../shared/chat-message';
/**
 * Bliksy UI Message — the same app-owned envelope Omniscient returns (`id`,
 * `schemaVersion`, ordered typed `parts`, plus `entityRefs` for source chips and
 * `langfuseTraceId` for feedback thumbs), so both agents render through one shape.
 *
 * Two Bliksy-specific properties of that envelope:
 *  - **`parts` are text and attached documents only.** A user turn carries the
 *    `file` handles of the documents it attached (plan 031 §3); an assistant
 *    turn stays text. No TOOL part is ever persisted or returned here: Bliksy's
 *    tools are recording mutations, not renderable content, and their audit
 *    lives in the generation's `steps`/`toolCalls` — which stays authoritative
 *    and unchanged (plan 009 §6.6).
 *  - **`createdAt` is always absent.** Bliksy timestamps generations, not
 *    messages, and a per-message timestamp is never fabricated (plan 009 §6.5).
 *
 * `content` rides along as the canonical TEXT PROJECTION of `parts` — the
 * expand/contract dual write (plan 009 §6.3) that keeps a frontend bundle from
 * before the parts walk rendering during a rolling deploy or a rollback.
 */ export const BliksyUIMessageSchema = ChatMessageEnvelopeSchema.extend({
    // Same two values as ChatMessageRoleSchema, kept as the agent's own enum so
    // existing consumers can go on comparing against `BliksyMessageRole`.
    role: z.enum([
        BliksyMessageRole.user,
        BliksyMessageRole.assistant
    ]),
    content: z.string()
});
export const LoadBliksyChatHistoryResponseSchema = z.object({
    messages: z.array(BliksyUIMessageSchema)
});
export const LoadBliksyChatHistoryErrorSchema = BaseErrorSchema;

//# sourceMappingURL=load-bliksy-chat-history.schema.js.map